import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import "./ColorPicker.css";
import { SketchPicker } from "react-color";
import { palette } from "../../themes/theme";
import PickerPortal from "./PickerPortal";

const presetColors = [
  { color: "#D0021B", title: "Red" },
  { color: "#F5A623", title: "Orange" },
  { color: "#F8E71C", title: "Yellow" },
  { color: "#8B572A", title: "Brown" },
  { color: "#7ED321", title: "Green" },
  { color: "#417505", title: "DarkGreen" },
  { color: "#0000FF", title: "Blue" },
  { color: "#9013FE", title: "Purple" },
  { color: "#50E3C2", title: "Cyan" },
  { color: "#B8E986", title: "LightGreen" },
  { color: "#000000", title: "Black" },
  { color: "#9B9B9B", title: "Grey" },
  { color: "#FFFFFF", title: "White" },
];

const ColorPicker = ({
  title,
  checked,
  color,
  setColor,
  type,
  noCheckbox = false,
  width = "50px",
  height = "30px",
  rightAlign = false,
}) => {
  const pickerRef = useRef();
  const colorBoxRef = useRef();
  const [showPicker, setShowPicker] = useState(false);
  const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (showPicker) {
      pickerRef.current.style.position = "fixed";
    }
    const handleOutsideClick = (event) => {
      if (
        showPicker &&
        (colorBoxRef.current !== event.target ||
          !event.target.closest(".color-box")) &&
        !event.target.closest(".color-picker")
      ) {
        setShowPicker(false);
      }
    };
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [showPicker]);

  // useEffect(() => {
  //   const adjustColorPickerPosition = () => {
  //     const colorPicker = pickerRef.current;
  //     if (colorPicker) {
  //       const colorPickerRect = colorPicker.getBoundingClientRect();
  //       // Check if the color picker overflows the right edge of the viewport
  //       if (colorPickerRect.right > window.innerWidth) {
  //         colorPicker.style.right = "0";
  //         colorPicker.style.left = "auto";
  //       } else {
  //         colorPicker.style.right = "auto";
  //         colorPicker.style.left = "0";
  //       }
  //       if (colorPickerRect.bottom > window.innerHeight) {
  //         colorPicker.style.bottom = "-150%";
  //       } else {
  //         colorPicker.style.bottom = "auto";
  //       }
  //     }
  //   };

  //   // Adjust position when the component is mounted
  //   if (showPicker) {
  //     adjustColorPickerPosition();
  //   }

  //   // Adjust position on window resize
  //   window.addEventListener("resize", adjustColorPickerPosition);

  //   // Cleanup event listener on component unmount
  //   return () => {
  //     window.removeEventListener("resize", adjustColorPickerPosition);
  //   };
  // }, [showPicker]);

  const rgbaToHex = (rgba) => {
    const match = rgba.match(
      /rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.?\d*))?\)/
    );
    if (match) {
      const [_, r, g, b, a] = match;
      const hex = `#${(+r).toString(16).padStart(2, "0")}
                        ${(+g).toString(16).padStart(2, "0")}
                        ${(+b).toString(16).padStart(2, "0")}`;
      return a && a !== "1"
        ? `${hex}${Math.round(+a * 255)
            .toString(16)
            .padStart(2, "0")}`
        : hex;
    }
    return rgba;
  };

  const openPicker = () => {
    if (colorBoxRef.current) {
      const rect = colorBoxRef.current.getBoundingClientRect();
      const pickerHeight = 300;
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      const shouldShowAbove =
        spaceBelow < pickerHeight && spaceAbove > pickerHeight;

      setPickerPosition({
        top: shouldShowAbove
          ? rect.top + window.scrollY - pickerHeight
          : rect.bottom + window.scrollY,
        left: rightAlign
          ? rect.right + window.scrollX - 220
          : rect.left + window.scrollX,
      });

      setShowPicker(true);
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        flexWrap: "wrap",
        alignItems: "center",
        position: "relative",
      }}
    >
      {!noCheckbox && (
        <FormControlLabel
          control={
            <Checkbox
              sx={{ p: 0 }}
              defaultChecked={checked}
              onChange={(e) => setColor(`${type}-transparent`, e)}
            />
          }
          sx={{ m: 0 }}
        />
      )}
      <div className="input-colorpicker" onClick={openPicker}>
        <div
          ref={colorBoxRef}
          style={{
            background: color,
            height,
            width,
          }}
          className="color-box"
        />
        {showPicker && (
          <PickerPortal>
            <div
              ref={pickerRef}
              style={{
                position: "absolute",
                top: `${pickerPosition.top}px`,
                left: `${pickerPosition.left}px`,
                zIndex: 9999,
              }}
              className={"color-picker"}
            >
              <SketchPicker
                color={rgbaToHex(color)}
                disableAlpha={true}
                onChange={(event) => {
                  setColor(type, event.hex);
                }}
                presetColors={presetColors.map((preset) => preset.title)}
                className="custom-picker"
              />
            </div>
          </PickerPortal>
        )}
      </div>
      <Typography sx={{ color: palette.text.dark, fontSize: 15, pl: 1 }}>
        {title}
      </Typography>
    </Box>
  );
};

export default ColorPicker;
